import React, { useState } from 'react';
// import './style.scss'
import ArabicLevel from './arabicLevel';
import ArabicRegister from './arabicRegister';
import ArabicShedule from './arabicSchedule';
import ArabicLearn from './arabicLearn';

const ArabicPage = (props) => {
	const [sideBarActiveState, setSideBarActiveState] = useState({ "levels": true, "register": false, "general": false, "learn": false});

    const arabic_data = props?.arabicData.length ? props?.arabicData[0] : null;
    // console.log(arabic_data?.offered_courses);
    const offered_courses = arabic_data?.offered_courses;
    const schedule_accordion = arabic_data?.schedule_accord;
    const learning_accordion = arabic_data?.learning_accord;
    const registration_accordion = arabic_data?.registration;

    const toggleActiveState = (btnName) => {
		switch (btnName) {
			case "levels":
				setSideBarActiveState({ "levels": true, "register": false, "general": false, "learn": false });
				break;
			case "register":
				setSideBarActiveState({ "levels": false, "register": true, "general": false, "learn": false });
				break;
			case "general":
				setSideBarActiveState({ "levels": false, "register": false, "general": true, "learn": false });
				break;
			case "learn":
				setSideBarActiveState({ "levels": false, "register": false, "general": false, "learn": true });
				break;
			default:
				break;
		}

	}

     return ( 
        <div className='arabic-page'>
            <div className='arabic-page-container'>
                <div className='left-section'>
                     <ul type='none'>
                        
                        <li onClick={() => toggleActiveState("levels")} className={sideBarActiveState.levels ? 'active' : ''}><a href="#levels-offered">Courses offered</a></li>
                        <li onClick={() => toggleActiveState("register")} className={sideBarActiveState.register ? 'active' : ''}><a href="#register">Register Today</a></li>
                        <li onClick={() => toggleActiveState("general")} className={sideBarActiveState.general ? 'active' : ''}><a href="#general-shedule">General Schedule</a></li>
                        <li onClick={() => toggleActiveState("learn")} className={sideBarActiveState.learn ? 'active' : ''}><a href="#learn">What you will learn</a></li>
					</ul>                   
                </div>
                <div className='right-section'>
                    {/*<div className='page-heading'>Classical Arabic online courses</div>*/}
                    <div className='page-heading'>{arabic_data?.page_header?.page_title ?? ''}</div>
                    <div className='dated'>
                        {/*<h2>Spring 2021</h2>*/}
                        <h2>{arabic_data?.page_header?.session}</h2>
                        <div className='starting-date' style={{display:"flex"}}>
                        {/*<img src={`${process.env.IMAGES_BASE_URL}/static-content/start-icon@3x.png`}  alt='starting-flag'/>*/}
                        <img src={arabic_data?.page_header?.duration[0]?.image_url}  alt='starting-flag'/>
                        {/*<p >Start Date: Februrary 1, 2021 </p>*/}
                        <p >{arabic_data?.page_header?.duration[0]?.session_date}</p>
                        </div>
                        <div className='ending-date' style={{display:"flex"}}>
                        {/*<img src={`${process.env.IMAGES_BASE_URL}/static-content/noun_finish_2751821.svg`}  alt='ending-flag'/>*/}
                        <img src={arabic_data?.page_header?.duration[1]?.image_url}  alt='ending-flag'/>
                        {/*<p >End Date: May 14, 2021</p>*/}
                        <p >{arabic_data?.page_header?.duration[1]?.session_date}</p>
                        </div>
                    </div>
                    <div className='description'>
                        <p>
                            {/*{arabic_data?.page_header?.description ?? ''}*/}
                            <div dangerouslySetInnerHTML={{ __html: arabic_data?.page_header?.description }}></div>
                        {/*Benefit from Bayan’s fully online semester-long classical Arabic courses. The courses offer a great way for members of the general public to study the language in a structured academic manner, with instructors who are experts in teaching Arabic as a foreign language to non-native speakers. These courses can also prepare high school students for advanced placement in undergraduate courses, and prepare undergraduates for admission to graduate school. Graduate students can refresh their understanding of the language and prepare for more advanced levels. These courses are suitable for anyone who wishes to improve their Arabic language fluency, including native speakers of dialectical Arabic who may wish to understand the formal language better.*/}
                        </p>
                    </div>
                    <ArabicLevel courses={offered_courses} />
                    <ArabicRegister registration_data= {registration_accordion}/>
                    <ArabicShedule general_schedule = {schedule_accordion}/>
                    <ArabicLearn learning = {learning_accordion}/>
                </div>
            </div>
        </div>
     );
}

export default ArabicPage; 
